<template>
  <v-card style="background-color: #F7F7F7" elevation="7">
    <v-row clas="bm-0 mb-0 pb-0">
      <v-col cols="12" class="mx-6">
        <v-card-subtitle>
          <h2 class="text-uppercase indigo--text">
            {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{ currentUser.roles[0].descripcion }}
          </h4>
          <v-divider class=""/>
        </v-card-subtitle>
      </v-col>
      <v-col cols="12" class="mt-0" v-if="toca">
        <v-card class="mx-4">
          <v-toolbar dark color="#286090" class="text-uppercase">
            <v-toolbar-title>Datos del Toca</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col cols="12" sm="6">
              <v-list>
                <v-list-item>
                  <v-chip class="mr-3" small color="green darken-2" text-color="white" label style="min-width: 97px !important">
                    <b>TOCA:</b>
                  </v-chip>
                  {{ toca.numero }}/{{ toca.anio }}
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-chip class="mr-3" small color="grey darken-2" text-color="white" label style="min-width: 97px !important">
                    <b>EXPEDIENTE:</b>
                  </v-chip>
                  {{ toca.expediente }}
                </v-list-item>
                <v-divider></v-divider>
              </v-list>
            </v-col>
            <!-- <v-divider inset vertical></v-divider> -->
            <v-col cols="12" sm="6">
              <v-list>
                <v-list-item>
                  <v-chip class="mr-3" small color="orange darken-2" text-color="white" label style="min-width: 97px !important">
                    <b>JUZGADO:</b>
                  </v-chip>
                  {{ toca.juzgado_data.nombre }}<br>
                  DISTRITO {{ toca.juzgado_data.distrito_data.nombre }}
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-chip class="mr-3" small color="#039C94" text-color="white" label style="min-width: 97px !important">
                    <b>MUNICIPIO:</b>
                  </v-chip>
                  {{ toca.juzgado_data.municipio_data.nombre }}
                </v-list-item>
                <v-divider></v-divider>
              </v-list>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mx-4 mt-3">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-toolbar v-if="toca && toca.excusas.length>=1" dense dark color="red lighten-2">
          <v-toolbar-title class="text-uppercase">Excusas Agregadas</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="toca && toca.excusas.length>=1">
          <v-alert
            v-if="toca"
            outlined
            color="red"
          >
            <span v-for="(excusa, i) in toca.excusas" :key="i">
              <v-row >
                <v-col class="grow">
                  <h4 class="mb-2" style="color: #F2711C;">MAGISTRADO EXCUSADO:</h4>
                  <span style="color:black;">{{ excusa.nombre_magistrado_excusado }}</span>
                </v-col>
                <v-col class="grow">
                  <h4 class="mb-2" style="color: #3D698E;">MAGISTRADO INTEGRANTE:</h4>
                  <v-select
                    dense
                    item-text="nombre"
                    item-value="id"
                    v-model="excusa.mag_integrante"
                    :items="listAllMagistrados"
                    persistent-hint
                    outlined
                    @change="updateExcusa(excusa)"
                  ></v-select>
                </v-col>
                <v-col align="right">
                  <v-btn
                    fab
                    dark
                    small
                    color="red"
                    @click="deleteExcusa(excusa)"
                  >
                    <v-icon dark>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="mt-n8 mb-4">
                <v-col>
                  <h4 class="mb-2" style="color:black;">MOTIVOS:</h4>
                  <span style="color:black;">{{ excusa.motivos }}</span>
                </v-col>
              </v-row>
              <v-divider class="mb-2"></v-divider>
            </span>
          </v-alert>
        </v-card-text>
        <v-toolbar dense dark color="indigo lighten-1">
          <v-toolbar-title class="text-uppercase">Agregar excusa</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              class="mt-n4"
            >
              <v-autocomplete
                label="Magistrado a excusar"
                item-text="magistrado"
                item-value="user_id"
                v-model="mag_excusado"
                :items="getAllPonencias"
                persistent-hint
                outlined
                required
                :rules="[rules.requiredSelect]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-n4"
            >
              <v-autocomplete
                label="Magistrado integranter"
                item-text="nombre"
                item-value="id"
                v-model="mag_integrante"
                :items="listAllMagistrados"
                persistent-hint
                outlined
                required
                :rules="[rules.requiredSelect]"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                class="mt-n7"
                v-model="motivo"
                outlined
                name="input-7-4"
                label="Motivos de la Excusa"
                required
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-n4">
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="red"
            :disabled="loading"
            @click="$router.push({ name:'SecAcuerdosIndex' })"
          >
            cancelar
          </v-btn>
          <v-btn
            dark
            color="success"
            @click="validate"
            :loading="loading"
          >
            excusar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <br>
  </v-card>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      toca: null,
      dialog: false,
      valid: false,
      loading: false,
      mag_excusado:'',
      mag_integrante:'',
      mag_integrante_select:'',
      motivo:'',
      rules: {
        required:v => !!v || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      }
    }),
    computed: {
      ...mapGetters(["roleUser", "currentUser", "getAllPonencias", "listAllMagistrados"])
    },
    mounted() {
      this.toca_id =  JSON.parse(localStorage.getItem("excusarToca"))
      if (this.toca_id == null) {
        this.$router.replace('/secacuerdos')
        return false
      }
      this.getToca();
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.$store.dispatch("GET_ALL_MAGISTRADOS", { url: "/list-magistrados" });
    },
    methods:{
      getToca(){
        this.$store.dispatch("GET_TOCAS", { url: "/toca/" + this.toca_id }).then(response => {
          this.toca = response.data.data.toca
        });
      },
      updateExcusa(item){
        this.$store.dispatch("UPDATE_CUENTA", { url: "/excusa/" + item.id,
          data:{
            mag_integrante: item.mag_integrante,
            apelacion_id: item
          }
        }).then(response => {
          this.$swal({
            title: "Éxito!!!",
            text: "Excusa actualizada correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
            timer:1500
          });
          this.getToca();
        })
        .catch(error => {
          console.log(error);
        });
      },
      deleteExcusa(item){
        this.$swal({
           title: '¿Desea eliminar la excusa?',
           text: '',
           icon: 'question',
           showCancelButton: true,
           confirmButtonText: "Aceptar"
         }).then((result) => {
           if (result.value) {
              this.$store.dispatch("DELETE_ITEM", { url: "/excusa/" + item.id }).then(response => {
                this.$swal({
                  title: "Éxito!!!",
                  text: "Excusa eliminada correctamente.",
                  icon: "success",
                  confirmButtonText: "Aceptar",
                  timer:1500
                });
                this.getToca();
              })
              .catch(error => {
                console.log(error);
              });
           }
         })
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.save();
        }
      },
      save() {
        var data = {
          toca_id: this.toca.id,
          mag_excusado: this.mag_excusado,
          mag_integrante: this.mag_integrante,
          motivo: this.motivo,
        }
        this.$store.dispatch("CREATE_OBSERVACION", { url: '/toca/excusar', data: data }).then(response => {
            this.loading = false;
            if (response.data.status == "ok") {
              this.$swal({
                title: "Éxito!!!",
                text: "Excusa agregada correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar"
              });
            }
            this.$router.push({ name:'SecAcuerdosIndex' })
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
            // this.$router.push('/bandeja')
          });
      },
    }
  };
</script>
